module.exports = __webpack_public_path__ + "static/Customised Roadmap-aa8b303e226e84329431e023e60cc180.webp";